// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__30ayI","boxTitle":"Qualiphy_boxTitle__iMe3b","box":"Qualiphy_box__2jkzH","toggleWrap":"Qualiphy_toggleWrap__1AwDv"};